export function caseResultsEvents() {
	const container = document.querySelector("#ilawyer-case-results");
	if (!container) return;
	async function firstClick(e) {
		container.removeEventListener("click", firstClick);
		try {
			const { initCaseResults } = await import("./case-results.js");
			const handleClick = initCaseResults(container);
			handleClick(e);
		} catch (err) {
			console.error("Failed to load case-results module:", err);
		}
	}
	container.addEventListener("click", firstClick);
}
